import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { SelectField } from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useReassignClearer from '../../../hooks/clearer/useReassignClearer';
import {
  ClearerReassignDataType,
  ClearerReassignInitialValues,
  ClearerReassignSchema,
} from '../../../models/clearer/clearerReassign.model';
import { useAppSelector } from '../../../redux/store';
import { getClearerId } from '../../../utils/utils';

interface IReassignClearerModal {
  tdata: any;
}

const ReassignClearerModal: React.FC<IReassignClearerModal> = ({ tdata }) => {
  const { reassignClearer, loading } = useReassignClearer();
  const { clearersList } = useAppSelector((state) => state.clearer);

  const onSubmit = (values: ClearerReassignDataType, actions: any) => {
    const clearerId = getClearerId(clearersList, values.clearer.split(' ')[1]);
    reassignClearer({ clearerId, cargoId: tdata.id });

    // if (resetInputFields) {
    actions.resetForm(ClearerReassignInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Reassign Clearer'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={ClearerReassignInitialValues}
          schema={ClearerReassignSchema}
          onSubmit={onSubmit}
        >
          <SelectField label="Clearer" name="clearer">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Clearer'}
            </option>
            {clearersList.map((data, index) => (
              <option
                key={index}
              >{`${data.lastName} ${data.firstName}`}</option>
            ))}
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Reassign Clearer
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default ReassignClearerModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
